import { gql } from 'apollo-angular';

const GET_CATEGORIES_BY_ORGANIZATION_ID_BUYERS = gql`
  query categoriesByOrganization($organizationId: Long!) {
    categoriesByOrganization(organizationId: $organizationId) {
      id
      name
      type
      effectiveDate
      actualSpend
      categorizationScheme {
        id
        name
      }
      parent {
        id
        name
        type
      }
    }
  }
`;

export default GET_CATEGORIES_BY_ORGANIZATION_ID_BUYERS;
